import React, { useState, useEffect } from 'react';
import BookHighlightManager from '../../services/home/BookHighlightManager';
import SectionHeader from './exploreBooksComponents/SectionHeader';
import BookGrid from './exploreBooksComponents/BookGrid';
import { useSelector } from 'react-redux';

const BestReadsBooks = () => {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('grid'); // Add view state
  const userId = useSelector(state => state.auth.user?.userId) || null;

  // Fetch Best Reads books
  const fetchBestReadsBooks = async () => {
    setLoading(true);
    try {
      const bestReadsBooks = await BookHighlightManager.getBestReadsBooks(userId);
      setBooks(bestReadsBooks);
    } catch (err) {
      console.error("Error fetching best reads books", err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBestReadsBooks();
  }, [userId]);

  const mappedBooks = books.map(b => ({
    id: b.bookId || b.id,
    title: b.bookName || b.title,
    author: b.author?.authorName || b.author,
    isbn: b.bookIsbn13 || b.isbn,
    description: b.bookDescription || " ",
    rating: Math.round(b.averageRating || 0),
    image: Array.isArray(b.bookImages) ? b.bookImages[0] : b.image,
    inStock: b.bookStockStatus,
  }));

  return (
    <div className="min-h-screen bg-white">
      <SectionHeader
        title="Best Reads"
        placeholder="Search for the best reads"
      />

      <div className="container mx-auto px-4 py-2">
        <BookGrid
          books={mappedBooks}
          view={view}
          onViewChange={setView} // Pass to enable toggle
          loading={loading}
        />

        {!loading && books.length === 0 && (
          <div className="mt-6 text-center text-gray-500">
            No best reads available.
          </div>
        )}
      </div>
    </div>
  );
};

export default BestReadsBooks;
